var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisa = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 19,
    rx: 3.5,
    fill: "white",
    stroke: "#E0E6EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3779 8.2641C16.3653 9.25064 17.2598 9.80122 17.9337 10.1286C18.626 10.4644 18.8585 10.6797 18.8559 10.98C18.8506 11.4397 18.3036 11.6426 17.7916 11.6504C16.8984 11.6643 16.3791 11.4101 15.9663 11.2178L15.6446 12.7187C16.0589 12.909 16.8258 13.0749 17.6212 13.0822C19.4881 13.0822 20.7096 12.1635 20.7162 10.739C20.7235 8.93121 18.2078 8.83118 18.2249 8.02314C18.2309 7.77808 18.4654 7.51662 18.9793 7.45016C19.2338 7.4165 19.9361 7.39084 20.7321 7.75634L21.0445 6.30428C20.6164 6.14885 20.0661 6 19.3811 6C17.6238 6 16.3878 6.93123 16.3779 8.2641ZM24.047 6.12511C23.7061 6.12511 23.4188 6.32335 23.2907 6.62763L20.6237 12.9755H22.4893L22.8606 11.9528H25.1403L25.3557 12.9755H27L25.5652 6.12511H24.047ZM24.308 7.97566L24.8465 10.5479H23.3719L24.308 7.97566ZM14.1159 6.12511L12.6454 12.9755H14.4231L15.893 6.12511H14.1159ZM11.4859 6.12511L9.63561 10.7878L8.88703 6.8232C8.79923 6.38066 8.45229 6.12511 8.06729 6.12511H5.04228L5 6.32402C5.62088 6.45837 6.32651 6.67502 6.75389 6.90682C7.0155 7.04843 7.0902 7.1722 7.1761 7.5088L8.59376 12.9755H10.4726L13.3529 6.12511H11.4859Z",
    fill: "url(#paint0_linear_2662_15839)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2662_15839",
    x1: 6.98735,
    y1: 9.88401,
    x2: 23.5547,
    y2: 3.80162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2449A5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Visa.35dcd6b24f6a0cf16dd88713b107f0bb.svg";